// src/services/apiService.js
const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

// Funkcja pomocnicza do wykonywania zapytań
const fetchData = async ({ url, method = 'GET', body = null, headers = {} }) => {
  const token = localStorage.getItem('access_token');
  
  const requestOptions = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...headers
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  };
  
  const response = await fetch(`${API_URL}${url}`, requestOptions);
  
  // Obsługa błędów HTTP
  if (!response.ok) {
    // Dla błędu 401 możemy dodać automatyczne odświeżanie tokenu
    if (response.status === 401) {
      // To miejsce na logikę odświeżania tokenu w przyszłości
      // Na razie po prostu zwracamy błąd
      throw new Error('Unauthorized access');
    }
    
    // Parse error response from backend
    let errorMessage = `API error: ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.detail) {
        errorMessage = errorData.detail;
      }
    } catch (e) {
      // If parsing fails, use default message
    }
    
    throw new Error(errorMessage);
  }
  
  // Zwróć dane jako JSON lub pusty obiekt jeśli nie ma danych
  return response.json().catch(() => ({}));
};

// Eksportowane funkcje API dla konkretnych zasobów
export const apiService = {
  // Urządzenia
  getDevices: () => fetchData({ url: '/api/devices/get-user-devices/' }),
  getHubs: () => fetchData({ url: '/api/devices/get-user-hubs/' }),
  getPendingDevices: () => fetchData({ url: '/api/devices/get-pending-devices/' }),
  approveDevice: (deviceUuid) => fetchData({ 
    url: `/api/devices/approve-device/${deviceUuid}/`, 
    method: 'POST' 
  }),
  rejectDevice: (deviceUuid) => fetchData({ 
    url: `/api/devices/reject-device/${deviceUuid}/`, 
    method: 'POST' 
  }),

  // Kody autoryzacyjne
  generateAuthCode: () => fetchData({ 
    url: '/api/devices/generate-auth-code/',
    method: 'POST'
  }),
  getAuthCode: () => fetchData({ url: '/api/devices/get-auth-code/' }),

  // Nowe metody do obsługi asynchronicznych zadań NestHub
  getHubPrintersAsync: (hubUuid) => fetchData({ 
    url: `/api/devices/nesthub/${hubUuid}/printers/`
  }),
  
  checkTaskStatus: (taskId) => fetchData({ 
    url: `/api/devices/tasks/${taskId}/status/`
  }),
  
  executeHubCommand: (hubUuid, command, data = {}, timeout = 30) => fetchData({
    url: `/api/devices/nesthub/${hubUuid}/execute/`,
    method: 'POST',
    body: JSON.stringify({ 
      command,
      data,
      timeout
    })
  }),

  // Printers
  getUserPrinters: () => fetchData({ url: '/api/printers/get-user-printers/' }),
  getPrinterDetail: (printerUuid) => fetchData({ url: `/api/printers/printer/${printerUuid}/` }),
  updatePrinterSettings: (printerUuid, data) => fetchData({ 
    url: `/api/printers/printer/${printerUuid}/update/`,
    method: 'POST',
    body: JSON.stringify(data)
  }),
  deletePrinter: (printerUuid) => fetchData({ 
    url: `/api/printers/printer/${printerUuid}/delete/`,
    method: 'DELETE'
  })
};